import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode, useState } from 'react';
import { BoardPage } from '../../components/BoardPage.js';
import { DashboardBoard } from '../../components/dashboard/DashboardBoard.js';
import { type Stage, StageToggle } from '../../components/filters/StageToggle.js';
import { MediaFilterBar } from '../../components/media/MediaFilterBar.js';
import { HomeSignals } from '../../components/signals/HomeSignals.js';
import { type MediaSearch, validateMediaSearch } from '../../lib/media-search.js';
import { type SignalsSearch, validateSignalsSearch } from '../../lib/signals-search.js';

function DashboardPage(): ReactNode {
  const [stage, setStage] = useState<Stage>('all');

  return (
    <BoardPage
      route="/dashboard"
      active="dashboard"
      contentSx={{ p: '24px' }}
      topBar={(board) => (
        <MediaFilterBar
          bar="dashboard"
          leading={<StageToggle value={stage} onChange={setStage} />}
          scope={board.scope}
          onScopeChange={board.applyScope}
          filters={board.filters}
          onFiltersChange={board.setFilters}
          dateWindow={board.dateWindow}
          accountIds={board.accountIds}
          kpiOptions={board.kpiOptions}
        />
      )}
    >
      {(board) => <DashboardBoard {...board} stage={stage} signals={<HomeSignals />} />}
    </BoardPage>
  );
}

export const Route = createFileRoute('/dashboard/')({
  validateSearch: (search: Record<string, unknown>): MediaSearch & SignalsSearch => ({
    ...validateMediaSearch(search),
    ...validateSignalsSearch(search),
  }),
  component: DashboardPage,
});
